module.exports = __webpack_public_path__ + "img/ni.e517c0d9.svg";